export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-disabled-960-bdf7b0d5f0ba0a022c489180111088e0.webp";